export default {
	actions: {
    async checkRestaurantOpen({ dispatch }) {
      await dispatch('apiGuestRequest', {method: 'GET', endpoint: '/schedule/is-open'})
    }
  }
}